
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-products",
      function () {
        return require("private-next-pages/new-products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-products"])
      });
    }
  